import Vue from 'vue'
// import store from '../store'

export default {

  getHealthCoachDetails (customerId) {
    return Vue.http.get(window.API_URL + `doctors/health_coach/customer/${customerId}/timelines`)
  },
  createGoal (data) {
    return Vue.http.post(window.API_URL + `doctors/health-coach-goals/create`, data)
  },
  updateGoal (data) {
    return Vue.http.post(window.API_URL + `doctors/health-coach-goals/${data.id}`, { health_coach_goals: { target_value: data.target_value } })
  },
  deleteGoal (id) {
    return Vue.http.delete(window.API_URL + `doctors/health-coach-goals/${id}`)
  },
  getCustomerGoalVitals (programEnrollmentId, customerId) {
    return Vue.http.get(window.API_URL + `doctors/customers/${customerId}/program_enrollments/${programEnrollmentId}/customer_goal_vitals`)
  },
  bulkUpdateGoal (programEnrollmentId, data) {
    return Vue.http.patch(window.API_URL + `doctors/health-coach-goals/${programEnrollmentId}/bulk_update`, data)
  },
  getTimelineAndProgress (customerId) {
    return Vue.http.get(window.API_URL + `doctors/health_coach/customer/${customerId}/program_enrollment_timeline`)
  },
  getActivityDetails (customerId, activityId, action) {
    return Vue.http.get(window.API_URL + `doctors/health_coach/customer/${customerId}/activity_details/${activityId}?action_type=${action}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/health_coach.js